var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _g4, _path6, _path7, _g5, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 52,
    viewBox: "0 0 192 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1753_166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 192,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M191.126 1.00293H0.925781V51.1291H191.126V1.00293Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1753_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.197 41.9624H20.7305L25.4638 51.1979H180.864L185.597 41.9624H131.864C131.33 45.2417 128.464 47.7848 125.064 47.7848C121.597 47.7179 118.73 45.2417 118.197 41.9624Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1753_166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 192,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.126 1.00293H0.925781V51.1291H191.126V1.00293Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1753_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.791 22.0188L131.057 3.68164H118.857L110.324 14.0549L102.324 3.74856H95.2573V11.1771L103.991 22.0188L89.3906 40.356H102.324L110.324 30.0497L118.124 40.0214C118.524 36.5414 121.457 33.7975 124.991 33.7975C125.391 33.7975 125.791 33.8644 126.191 33.9313L116.791 22.0188Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1753_166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 192,
    height: 51
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.126 1.00293H0.925781V51.1291H191.126V1.00293Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1753_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.994 35.4028C127.994 35.4028 130.394 37.8121 130.394 40.8237C130.394 43.8353 127.994 46.1776 124.994 46.1776C121.994 46.1776 119.594 43.7683 119.594 40.7568C119.594 37.7452 122.06 35.4028 124.994 35.4028Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.13 27.4397H149.73L144.864 20.4127L140.13 27.4397ZM125.797 30.7859L144.864 3.68164L170.53 40.356H158.597L154.664 34.6675H135.33L132.397 39.1514L125.797 30.7859Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1753_166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 192,
    height: 51
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.126 1.00293H0.925781V51.1291H191.126V1.00293Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1753_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.054 5.01837H184.321V6.89225H185.254C185.721 6.89225 186.121 6.42378 186.121 5.95531C186.121 5.35299 185.654 5.01837 185.054 5.01837ZM186.121 8.02996L187.588 10.3723H185.988L184.254 7.76226V10.3723H182.921V3.67989H185.054C186.321 3.67989 187.454 4.61683 187.454 5.88839V6.08916C187.454 7.0261 186.921 7.69534 186.121 8.02996ZM185.121 2.27449C182.521 2.27449 180.388 4.41606 180.388 7.09302C180.388 9.70306 182.521 11.8446 185.121 11.8446C187.721 11.8446 189.854 9.70306 189.854 7.09302C189.921 4.41606 187.721 2.27449 185.121 2.27449ZM189.388 2.74296C190.588 3.94759 191.121 5.35299 191.121 7.0261C191.121 8.6992 190.521 10.1046 189.388 11.3092C188.188 12.5139 186.788 13.0493 185.121 13.0493C183.454 13.0493 182.054 12.4469 180.854 11.3092C179.654 10.1046 179.121 8.6992 179.121 7.0261C179.121 5.35299 179.721 3.94759 180.854 2.74296C181.988 1.53832 183.454 1.00293 185.121 1.00293C186.788 1.00293 188.254 1.60525 189.388 2.74296Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.535 3.68164V23.2904L172.402 40.356H186.402L191.202 31.1205H171.735V3.68164H160.535Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1753_166",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 192,
    height: 51
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.126 1.00293H0.925781V51.1291H191.126V1.00293Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1753_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.7258 22.8219V3.68164H83.2591V23.7589C83.2591 27.9081 79.9258 31.2544 75.7924 31.2544C71.6591 31.2544 68.3258 27.9081 68.3258 23.7589V3.68164H61.7924L57.9258 11.2441V22.8219C57.9258 32.7267 65.9924 40.7576 75.8591 40.7576C85.6591 40.7576 93.6591 32.7267 93.7258 22.8219Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5258 2.40771L21.2591 19.8749L13.5924 3.67927H0.925781L20.1258 40.8221L30.5924 23.6896L40.9924 40.8221L60.1258 3.67927H47.4591L39.8591 19.8749L30.5258 2.40771Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLogo2);
export default __webpack_public_path__ + "static/media/product-logo-2.fef3cd294c790a1a220fa663561e3656.svg";
export { ForwardRef as ReactComponent };